// extracted by mini-css-extract-plugin
export default {"container":"EventList_container__KCGt5","cardContainer":"EventList_cardContainer__VU7Qu"};